import FixedContributionConfig from "./FixedContributionConfig";

export default class FixedContributionService {
	static setFixedContribution(value, id) {
		return new Promise(async (resolve, reject) => {
			try {
				let body = JSON.stringify(value);
				let endpoint = FixedContributionConfig.endpoint;
				let response = await FixedContributionConfig.APIConnector.post(
					endpoint,
					{
						body
					}
				);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static updateFixedContribution(id, value) {
		return new Promise(async (resolve, reject) => {
			try {
				let body = JSON.stringify(value);
				let endpoint = FixedContributionConfig.endpoint;
				let response = await FixedContributionConfig.APIConnector.put(
					endpoint,
					{
						body
					}
				);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static deleteFixedContribution(fixedContributionId, fixedContribution) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint =
					FixedContributionConfig.endpoint + "/" + fixedContributionId;
				let response = FixedContributionConfig.APIConnector.delete(endpoint);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static getFixedContributionList(searchText, page, size) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint = FixedContributionConfig.endpoint;
				if (page && size) endpoint += "?page=" + page + "&size=" + size;
				let response = await FixedContributionConfig.APIConnector.get(endpoint);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/provider/FixedContribution/FixedContributionService.js